import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '@/components/ui';
import {cn} from '@/lib/utils';
import {ReactNode} from 'react';
import {useGlobalLoader} from '@/hooks/use-global-loader.ts';

type Props = {
  title?: string,
  children: ReactNode,
  className?: string,
  onClose?: () => void,
  onLoad?: (node: HTMLDivElement) => void,
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl',
}
const ADialog = ({title = '', children, onClose, className, onLoad, size = 'md'}: Props) => {
  const {preventDialogClose} = useGlobalLoader();
  return (
    <Dialog open={true} onOpenChange={(open) => {
      if (!open && onClose) {
        onClose();
      }
    }}>
      <DialogContent
        className={cn('app-dialog overflow-y-auto max-h-screen ', `size-${size}`, className)}
        ref={(node) => {
          if (onLoad && node) {
            onLoad(node);
          }
        }}
        {...preventDialogClose()}
      >
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription className="hidden">{title}</DialogDescription>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
};

export {ADialog};